import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=b342fdc2&scoped=true&"
import script from "./keyboard.vue?vue&type=script&lang=js&"
export * from "./keyboard.vue?vue&type=script&lang=js&"
import style0 from "./keyboard.vue?vue&type=style&index=0&id=b342fdc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b342fdc2",
  null
  
)

export default component.exports